import { SVGProps, Ref, forwardRef, memo } from "react";

const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M24.812 8.784a10.996 10.996 0 0 0-9.529-5.5c-6.075 0-11 4.925-11 11s4.925 11 11 11c4.852 0 8.97-3.14 10.432-7.5m-.903-9-5.529-.5m5.529.5.471-5.5"
      stroke="#F08517"
      strokeWidth="3"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export { Memo as Load };
